import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MachineryLoanPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    village: '',
    post: '',
    block: '',
    district: '',
    pin: '',
    state: ''
  });

  const [files, setFiles] = useState({
    aadharPhoto: null,
    panPhoto: null,
    tractorRCPhoto: null
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files: selectedFiles } = e.target;
    if (selectedFiles && selectedFiles.length > 0) {
      setFiles(prev => ({ ...prev, [name]: selectedFiles[0] }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const submitData = new FormData();
    Object.keys(formData).forEach(key => {
      submitData.append(key, formData[key]);
    });

    if (files.aadharPhoto) submitData.append('aadharPhoto', files.aadharPhoto);
    if (files.panPhoto) submitData.append('panPhoto', files.panPhoto);
    if (files.tractorRCPhoto) submitData.append('tractorRCPhoto', files.tractorRCPhoto);

    try {
      const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');
      const envApiUrl = process.env.REACT_APP_API_URL?.trim();
      const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
      const res = await fetch(`${API_URL}/services/loan`, {
        method: 'POST',
        body: submitData
      });
      const data = await res.json();
      if (data.success) {
        setIsSubmitted(true);
      } else {
        alert(data.message || 'Error submitting application.');
      }
    } catch (err) {
      console.error(err);
      alert('Network error while submitting.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="page-container" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header />
        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '40px 20px', background: '#f8fafc' }}>
          <div style={{ background: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)', textAlign: 'center', maxWidth: '500px' }}>
            <h2 style={{ color: '#4ba242', marginBottom: '20px' }}>Application Submitted Successfully!</h2>
            <p style={{ color: '#64748b', marginBottom: '30px' }}>Your machinery loan application has been received. Our team will review your details and contact you soon.</p>
            <button onClick={() => window.location.href = '/'} style={{ padding: '12px 24px', background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
              Return Home
            </button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="page-container" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ flex: 1, padding: '40px 20px', background: '#f8fafc', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ width: '100%', maxWidth: '700px', marginBottom: '15px' }}>
          <button 
            onClick={() => navigate(-1)} 
            style={{ display: 'flex', alignItems: 'center', gap: '8px', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#475569', fontWeight: '500', padding: '8px 0' }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
            Back
          </button>
        </div>
        <div style={{ width: '100%', maxWidth: '700px', background: '#fff', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          <div style={{ background: '#0ea5e9', color: '#fff', padding: '16px', textAlign: 'center' }}>
            <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>Apply for Machinery Loan</h2>
          </div>
          
          <form onSubmit={handleSubmit} style={{ padding: '30px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Full Name / पूरा नाम <span style={{color: 'red'}}>*</span></label>
                <input type="text" name="fullName" required value={formData.fullName} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Phone Number / मोबाइल नंबर <span style={{color: 'red'}}>*</span></label>
                <input type="tel" name="phoneNumber" required value={formData.phoneNumber} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Address -</label>
                <div></div>
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', paddingLeft: '20px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Vill -</label>
                <input type="text" name="village" required value={formData.village} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', paddingLeft: '20px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Post -</label>
                <input type="text" name="post" required value={formData.post} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', paddingLeft: '20px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Block -</label>
                <input type="text" name="block" required value={formData.block} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', paddingLeft: '20px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>District Name -</label>
                <input type="text" name="district" required value={formData.district} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', paddingLeft: '20px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>Pin -</label>
                <input type="text" name="pin" required value={formData.pin} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', paddingLeft: '20px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>State -</label>
                <input type="text" name="state" required value={formData.state} onChange={handleChange} style={{ padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', width: '100%' }} />
              </div>
              
              <h3 style={{ marginTop: '20px', marginBottom: '10px', fontWeight: 'bold' }}>अपलोड फोटो</h3>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>आधार कार्ड का फोटो -</label>
                <input type="file" name="aadharPhoto" required accept="image/*,application/pdf" onChange={handleFileChange} style={{ width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>पैन कार्ड का फोटो -</label>
                <input type="file" name="panPhoto" required accept="image/*,application/pdf" onChange={handleFileChange} style={{ width: '100%' }} />
              </div>

              <div className="form-group" style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
                <label style={{ fontWeight: '500', color: '#334155' }}>ट्रैक्टर RC का फोटो -</label>
                <input type="file" name="tractorRCPhoto" required accept="image/*,application/pdf" onChange={handleFileChange} style={{ width: '100%' }} />
              </div>

              <button type="submit" disabled={isLoading} style={{ background: '#0ea5e9', color: '#fff', padding: '16px', border: 'none', width: '100%', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer', marginTop: '20px' }}>
                {isLoading ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MachineryLoanPage;


